import { useTranslation } from "../../common/translation-context";
import ToastMessageFunction from "../../common/toast-message-function";
import DataGrid from "../../common/data-grid/data-grid";
import React, { useEffect, useCallback, useState } from "react";
import {
  APP_VIEW,
  IB_BP_RATE_FREEZE,
  IB_FISCAL_DATES,
  CODE_COUNTRY_IB,
} from "../../constants/constant";
import { getDataWAuth, putDataWAuth } from "../../utils/api-service";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Card, CardContent } from "@deere/fuel-react";
import Dropdown from "../../common/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { fetchRatesStatus } from "../../store/slices/interestBearing/ratesStatusReducer";


function RatesDashboard() {
  const dispatch = useDispatch();
  const ratesStatusState = useSelector((state) => state.ratesStatusState);
  const { translate: t } = useTranslation();
  const toastManager = ToastMessageFunction();

  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const [fisMonthYear, setFisMonthYear] = useState("");
  const [fiscalMonthDates, setFiscalMonthDates] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [dataFiscalMonth, setDataFiscalMonth] = useState([]);

  useEffect(() => {
    getFiscalDates();
  }, []);

  const getFiscalDates = async () => {
    try {
      const res = await getDataWAuth(IB_FISCAL_DATES);
      if (res) {
        const data = res.data;
        setDates(data);
        setMonth(data, data[1].datesDTO.fisMonthyear);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoaderVisible(false);
    }
  };

  const setDates = (data) => {
    const prevMonth = `Prior to Last - ${data[0].datesDTO.startDate} - ${data[0].datesDTO.endDate}`;
    const currMonth = `Previous - ${data[1].datesDTO.startDate} - ${data[1].datesDTO.endDate}`;
    const upMonth = `Current - ${data[2].datesDTO.startDate} - ${data[2].datesDTO.endDate}`;

    setFiscalMonthDates([prevMonth, currMonth, upMonth]);
    setDataFiscalMonth(data);
  };

  const setMonth = (data, month) => {
    const labels = ["Prior to Last", "Previous", "Current"];

    for (let i = 0; i < data.length; i++) {
      if (month === data[i].datesDTO.fisMonthyear) {
        setSelectedMonth(
          `${labels[i]} - ${data[i].datesDTO.startDate} - ${data[i].datesDTO.endDate}`
        );
        setFisMonthYear(data[i].datesDTO.fisMonthyear);
        break;
      }
    }
  };

  useEffect(() => {
    if (fisMonthYear) {
      dispatch(fetchRatesStatus(fisMonthYear));
    }
  }, [fisMonthYear, dispatch]);

  // const getRatesStatus = async (fisMonthYear) => {
  //   dispatch(fetchRatesStatus(fisMonthYear));
  // };

  const getCustomRowId = (row) => row?.freezeId;

  const showToast = useCallback(
    (message, severity) => {
      toastManager.getToast(message, severity);
    },
    [toastManager]
  );

  const handleLockClick = async () => {
    setIsLoaderVisible(true);
    try {
      const res = await putDataWAuth(IB_BP_RATE_FREEZE, {}, { fisMonthYear });
      if (res) {
        showToast(res.data.message, "success");
        dispatch(fetchRatesStatus(fisMonthYear));
      }
    } catch (error) {
      showToast("Failed to Lock rates !", "error");
    } finally {
      setIsLoaderVisible(false);
    }
  };

  const handleMonthChange = (value) => {
    const selectedData = dataFiscalMonth.find((data) => value.includes(data.datesDTO.startDate) ? "found" : null);
    if (selectedData) {
      setMonth(dataFiscalMonth, selectedData.datesDTO.fisMonthyear);
    }
  };

  const columns = [
    {
      field: "role",
      width: 300,
      editable: false,
      renderHeader: () => <strong>Role</strong>,
      renderCell: ({ row }) => {
        if (row.role !== "CCM") {
          return row.role;
        } else {
          const country = Object.entries(CODE_COUNTRY_IB).find(([key, value]) => value === row.countryCode);
          const countryName = country ? country[0] : row.countryCode;
          return `${row.role} - ${countryName}`;
        }
      },
    },
    {
      field: "updatedBy",
      width: 330,
      editable: false,
      renderHeader: () => <strong>ID</strong>,
    },
    {
      field: "isFreezed",
      width: 330,
      editable: false,
      renderHeader: () => <strong>Status</strong>,
      renderCell: ({ row }) => (row.freezed ? <CheckCircleRoundedIcon color="success" /> : null),
    },
  ];

  return (
    <div>
      {toastManager.toast}
      <div style={{ marginLeft: "20px" }}>
        <strong>{t("ratesDashboard")}</strong>
      </div>
      <div style={{ marginTop: "20px", marginLeft: "20px", marginRight: "20px" }}>
        <Box>
          <Card>
            <CardContent>
              <h4>{t("filter")}</h4>
              {selectedMonth && (
                <Dropdown value={selectedMonth} options={fiscalMonthDates} onDropdownChange={handleMonthChange} />
              )}
            </CardContent>
          </Card>
        </Box>
      </div>
      <DataGrid
        view={APP_VIEW.IB_BP}
        isLocked={ratesStatusState?.isLocked}
        getRowId={getCustomRowId}
        columns={columns}
        rows={ratesStatusState?.ratesStatus || []}
        handleLockClick={handleLockClick}
        isLoaderVisible={ratesStatusState?.isLoading || isLoaderVisible}
      />
    </div>
  );
}

export default RatesDashboard;